var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgYeear(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.088,
    height: 19.084,
    viewBox: "0 0 19.088 19.084",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_3270",
    "data-name": "Group 3270",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3147",
    "data-name": "Path 3147",
    d: "M2658.365,2287.4a9.542,9.542,0,1,1-9.539,9.543A9.562,9.562,0,0,1,2658.365,2287.4Zm8.528,9.554a8.522,8.522,0,1,0-8.523,8.509A8.508,8.508,0,0,0,2666.892,2296.949Z",
    transform: "translate(-2648.826 -2287.395)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3148",
    "data-name": "Path 3148",
    d: "M2661.632,2296.694a2.067,2.067,0,0,1-.61,2.728,2.011,2.011,0,0,1-2.78-2.806,2.046,2.046,0,0,1,2.718-.585,1.88,1.88,0,0,1,.16-.211q1.669-1.674,3.344-3.338a.925.925,0,0,1,.437-.234.417.417,0,0,1,.458.258.481.481,0,0,1-.037.531,1.859,1.859,0,0,1-.192.205q-1.654,1.655-3.309,3.307A1.749,1.749,0,0,1,2661.632,2296.694Zm-1.738,2.054a.994.994,0,1,0-.989-1.005A.984.984,0,0,0,2659.893,2298.748Z",
    transform: "translate(-2650.355 -2288.212)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3149",
    "data-name": "Path 3149",
    d: "M2658.862,2291.013a6.944,6.944,0,0,1,2.759.564c.342.151.48.419.359.705s-.41.368-.757.228a5.383,5.383,0,0,0-5.734.782,5.265,5.265,0,0,0-2.017,4.123c-.015.48-.337.76-.708.6a.529.529,0,0,1-.315-.553,6.56,6.56,0,0,1,6.413-6.444Z",
    transform: "translate(-2649.437 -2288.005)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3150",
    "data-name": "Path 3150",
    d: "M2667.849,2298.149v.035a.53.53,0,0,1-.509.585c-.288,0-.481-.229-.516-.56-.049-.472-.1-.946-.2-1.412a4.66,4.66,0,0,0-.27-.771.519.519,0,0,1,.23-.737c.285-.127.553.006.705.347A6.736,6.736,0,0,1,2667.849,2298.149Z",
    transform: "translate(-2651.773 -2288.719)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYeear);
export default __webpack_public_path__ + "static/media/yeear.392f35c4dbd0e128931028c7ef1a3e87.svg";
export { ForwardRef as ReactComponent };